import { render } from "./AdminUserNotificaion.vue?vue&type=template&id=5e16be7a&scoped=true"
import script from "./AdminUserNotificaion.vue?vue&type=script&lang=js"
export * from "./AdminUserNotificaion.vue?vue&type=script&lang=js"

import "./AdminUserNotificaion.vue?vue&type=style&index=0&id=5e16be7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e16be7a"]])

export default __exports__